import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
// import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';

import messages from 'aurora-translations';
import Typography from '@material-ui/core/Typography';
import history from 'aurora-utils/history';
import { injectIntl } from 'react-intl';
import { keyEmptyCheck } from 'aurora-utils/utils';
import LocationGrayIcon from 'aurora-images/Location.svg';

import styles from './styles';

function BuildingDisplay(props) {
  const { building, classes, intl, applicationId, confirmDelete, locale } = props;

  const isRenewal = window.location.pathname.split('/').includes('pma-renewal');
  const isAmendment = window.location.pathname.split('/').includes('pma-amendment');
  const isRegistration = window.location.pathname.split('/').includes('pma-registration');

  const getUnitsChip = () => (
    <Chip
      label={intl.formatMessage({ ...messages.selected_units }, { s: building.count })}
      className={classes.selectedUnitsChip}
      onClick={() => {
        history.push({
          pathname: '/app/services/pma-selected-building-units/',
          search:
            '?id=' +
            applicationId +
            '&buildingRegNumber=' +
            building.buildingRegNumber +
            '&buildingPlotId=' +
            building.id +
            '&isSelectable=' +
            (isRenewal ? 'false' : 'true') +
            (isRegistration
              ? '&isRegistration=true'
              : isRenewal
              ? '&isRenewal=true'
              : isAmendment
              ? '&isAmendment=true'
              : ''),
          state: { building },
        });
      }}
    />
  );

  const buildingLocation =
    `${locale === 'en' ? building?.municipalityNameEn : building?.municipalityNameAr}` +
    ' ' +
    `${locale === 'en' ? building?.districtNameEn : building?.districtNameAr}  ${
      locale === 'en' ? building?.communityNameEn : building?.communityNameAr
    }`;

  return (
    <div className={classes.buildingWrapper}>
      <div className={classes.buildingContainer}>
        <Box
          sx={{
            display: { xs: 'flex', md: 'inline-block' },
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <div className={classes.buildingInfo}>
            <img src='/images/Building-img.svg' alt='' height='72px' />
            <div>
              <Typography variant='h6' component='h1' className={classes.Title}>
                {building?.buildingNumber}
              </Typography>
              <Typography className={classes.shortDetails}>
                <Hidden smDown>
                  <>
                    {buildingLocation}
                    <br />
                  </>
                </Hidden>
                {`${building?.unitRegNumber ? building?.unitRegNumber + ' |' : ''}  ${building?.buildingRegNumber}`}
              </Typography>
            </div>
          </div>
          <Hidden mdUp>{getUnitsChip()}</Hidden>
        </Box>
        <Box
          sx={{
            display: { xs: 'flex', md: 'inline-block' },
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Hidden mdUp>
            <Typography className={classes.propertyAddress} color='#8C9099'>
              <img src={LocationGrayIcon} alt='' />
              {buildingLocation}
            </Typography>
          </Hidden>
          <div className={classes.buildingActionsWrapper}>
            <Hidden smDown>{getUnitsChip()}</Hidden>
            {!isRenewal && (
              <>
                <Button
                  variant='text'
                  onClick={() => {
                    history.push({
                      pathname: '/app/services/pma-selected-building-units/',
                      search:
                        '?id=' +
                        applicationId +
                        '&buildingRegNumber=' +
                        building.buildingRegNumber +
                        '&buildingPlotId=' +
                        building.id +
                        '&isSelectable=true' +
                        (isRegistration
                          ? '&isRegistration=true'
                          : isRenewal
                          ? '&isRenewal=true'
                          : isAmendment
                          ? '&isAmendment=true'
                          : ''),
                      state: { building },
                    });
                  }}
                >
                  <img src='/images/edit-black.svg' alt='edit-black' />
                  {keyEmptyCheck('Edit')}
                </Button>
                <Button
                  variant='text'
                  onClick={() => {
                    confirmDelete(true);
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <img src='/images/delete-icon-black.svg' alt='delete-icon-black' />
                  {keyEmptyCheck('remove')}
                </Button>
              </>
            )}
          </div>
        </Box>
      </div>
    </div>
  );
}

BuildingDisplay.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationId: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  building: PropTypes.object.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};
export default withStyles(styles)(injectIntl(BuildingDisplay));
